<template>
  <div class="row">
    <h5 class="col-12 h2 mb-0 mt-4 mb-2">Culturas</h5>
    <h5 class="card-title ml-3 text-uppercase text-muted mb-4 h5">Culturas vinculadas ao cliente</h5>
    <div class="row col-12 d-flex justify-content-between">
      <div class="card-deck col-3 ml-1" v-for="(culture, index) in cultures" :key="culture.name">
        <div class="card text-white mb-3">
          <div 
            :class="[
              `card-header row d-flex justify-content-between`,
              culture.culture_main == true ? `bg-green` : `bg-blue`
            ]" 
            style="max-height: 3.5rem;"
          >
            <h5 class="card-title text-uppercase text-white h3">{{ culture.culture_main == true ? 'Cultura Principal' : 'Cultura ' + (index +1 )}}</h5>
          </div>
          <div class="card-body bg-white row d-flex justify-content-center align-center">
            <h5 class="card-title text-uppercase h3">{{ culture.culture_name }} </h5>
          </div>
          <div class="row bg-white d-flex justify-content-center" >
            <div class="col-10 d-flex justify-content-between bg-light mb-2">
              <span class="text-dark mt-2 mb-2">{{ culture.culture_name }}</span>
              <span class="text-dark mt-2 mb-2">{{ culture.culture_area }}m²</span>
            </div>
              <div class="col-10 d-flex justify-content-between bg-light mb-2">
                <span class="text-dark mt-2 mb-2">Ciclo</span>
                <span class="text-dark mt-2 mb-2">{{ culture.cicle ? culture.cicle.description : 'Não cadastrado' }}</span>
              </div>
              <div class="col-10 d-flex justify-content-between bg-light mb-4">
                <span class="text-dark mt-2 mb-2">Custo/Índice Tecnológico</span>
                <span class="text-dark mt-2 mb-2"> R$ {{ culture.cost_hectare }}</span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";

export default {
  name: 'cultures-cri',
  props: {
    cultures: Array
  },
  components: { Multiselect },
  data () {
    return {
      culture: {
        cicles: [
          {
            description: ''
          }
        ]
      }
    }
  },
  methods: {
    async getCicles() {
      try {
        const response = await this.$http.secured.get(`/api/v1/cultures/${this.culture && this.culture.id}/cicles`)
        this.culture.cicles = response.data || []
        this.culture = Object.assign({}, this.culture)
      } catch (error) { console.error(error)} 
    }
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0 0 2rem 0 rgb(136 152 170 / 25%);
}
</style>